import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import type { RnbCalculatorPayload } from 'typings'
import { useFetch } from './useFetch'
import { mapPromotionType } from './usePromotions'

type Params = {
  id: string
  options?: Partial<UseQueryOptions<RnbCalculatorPayload>>
}

export function usePromotionQuery(params: Params) {
  const { id, options } = params

  const { fetcherWrapper } = useFetch()

  const url = new URL(
    `/api/proxy/rnb/pvt/calculatorconfiguration/${id}`,
    window.location.origin
  ).toString()

  async function fetcher(): Promise<RnbCalculatorPayload> {
    return fetcherWrapper(url)
      .then((r) => r.json())
      .then((response: RnbCalculatorPayload) => ({
        ...response,
        type: mapPromotionType(response.type),
      }))
  }

  return useQuery<RnbCalculatorPayload>({
    queryKey: ['promotion-by-id', id],
    queryFn: fetcher,
    ...options,
    refetchOnMount: true,
  })
}
